import axios from './axios_interceptors'
import config from '@/services/config'
import { tokenExpired } from '@/auth/utils'

export const getUrlManageSubscription = () => {
  return axios.get(`${config.urlCore}/api/v3/plans/manage-subscription/`,
    {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
    })
    .then(response => response.data.response)
    .catch(error => {
      if (error.response.status === 401) tokenExpired()
      return error.response
    })
}